import { WidgetLibraryItem } from "../../../utils/util-types";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import RemoveIcon from "../../../assets/icons/remove_icon.svg";
import { ReactComponent as AddIcon } from "../../../assets/icons/add-icon.svg";

export interface WidgetItemInterface {
  widget: WidgetLibraryItem;
  onAddClick: (widget: WidgetLibraryItem) => void;
  onRemoveClick: (widget: WidgetLibraryItem) => void;
}
export default function WidgetItem({
  widget,
  onAddClick,
  onRemoveClick,
}: WidgetItemInterface) {
  return (
    <div className={`widget-card`}>
      {/* <DragIndicatorIcon className="drag-icon" /> */}

      <div className="widget-detail-container">
        <div className="widget-icon">
          <span />
        </div>

        <div className="widget-text">
          <h4>{widget?.name}</h4>
          <p>{widget?.description}</p>
        </div>
      </div>
      {widget.isAdded && (
        <img
          className="remove-icon"
          src={RemoveIcon}
          alt="remove"
          draggable={false}
          onClick={() => {
            onRemoveClick(widget);
          }}
        />
      )}

      {!widget.isAdded && (
        <AddIcon
          className="add-icon"
          onClick={() => {
            onAddClick(widget);
          }}
        />
      )}
    </div>
  );
}
